import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridRenderCellParams, ptBR } from '@mui/x-data-grid';
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";

const DataGridComponent = (props: any) => {
  const [pageSize, setPageSize] = useState<number>(20);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [rowsCount, setRowsCount] = useState<number>(0);
  const [rows, setRows] = useState<any[]>([]);
  const [columns, setColumns] = useState<GridColDef[]>([]);
  let loading = false;
  let initializing = false;

  let lastColumns: GridColDef[] = [
    {
      field: props.fieldId, filterable: false, sortable: false, headerName: 'Ação', minWidth: (props.minWidthActionsArea ?? 250),
      renderCell: (params: GridRenderCellParams<number>) => (
        <strong>
          <Button
            onClick={() => props.onEditAction(params.value?.valueOf())}
            variant="contained"
            size="sm"
            hidden={props.hideEdit || false}
            style={{ marginLeft: 16 }}>
            <FontAwesomeIcon icon={faEdit} />
            Editar
          </Button>

          <Button
            onClick={() => props.onDeleteAction(params.value?.valueOf())}
            variant="outlined"
            size="sm"
            style={{ marginLeft: 16 }}>
            <FontAwesomeIcon icon={faTrash} />
            Excluir
          </Button>
        </strong>
      ),
    },
  ];

  useEffect(() => {
    if (props.hideButtons) {
      setColumns(props.columns);
    }
    else {
      setColumns(props.columns.concat(lastColumns));
    }
  }, []);

  useEffect(() => {
    if (loading) {
      return;
    }

    loading = true;
    setRows(props.rows ?? []);
    loading = false;
  }, [props.rows]);

  useEffect(() => {
    if (initializing) {
      return;
    }

    (async () => {
      await atualizaListaBusca();
      initializing = false;
    })();

  }, [pageSize, pageNumber]);


  const atualizaListaBusca = async () => {
    if (loading) {
      return;
    }

    loading = true;

    try {
      if (props?.atualizaListaBuscaEventCallBack == null) {
        return;
      }

      let response = await props?.atualizaListaBuscaEventCallBack(pageSize, pageNumber); //zaxios.get(`${props.apiBusca}?page=${pageNumber}&pageSize=${pageSize}&criterio=${criterio}`);
      if (response?.data == null) {
        return;
      }

      setRows(response.data.data ?? []);
      setRowsCount(response.data.total);
    } catch (error) {
      console.log(error);
    }
    finally {
      document.body.style.cursor = "default";
      setTimeout(function () { loading = false; }, 5000);
      initializing = false;
    }
  }

  function getHeigth() {
    if ((props.height ?? '') == '') {
      return '100%';
    }
    else if (parseInt(props.height)) {
      return parseInt(props.height);
    }
    else {
      return props.height;
    }
  }

  function setPageNumberEvent(page: number) {
    setPageNumber(page);
  }

  function setPageSizeEvent(size: number) {
    setPageSize(size);
  }

  return (
    <div style={{ height: (getHeigth() || '100%'), width: '100%' }}> 
      <DataGrid
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        rows={rows}
        rowHeight={38}
        columns={columns}
				style={{height: '100%'}}
        page={(pageNumber - 0)}
        paginationMode="server"
        hideFooterPagination={props.hideFooter || false}
        hideFooterSelectedRowCount={props.hideFooter || false}
        rowCount={rowsCount ?? 0}
        pageSize={props.hideFooter == true ? 100 : pageSize}
        onPageChange={(page) => setPageNumberEvent(page)}
        onPageSizeChange={(pageSize) => setPageSizeEvent(pageSize)}
        rowsPerPageOptions={props.hideFooter == true ? [] : [20, 40, 60, 100]} />
    </div>
  )
}

export default DataGridComponent;